import { render, staticRenderFns } from "./missing-license.vue?vue&type=template&id=c961fada&scoped=true"
import script from "./missing-license.vue?vue&type=script&lang=js"
export * from "./missing-license.vue?vue&type=script&lang=js"
import style0 from "./missing-license.vue?vue&type=style&index=0&id=c961fada&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c961fada",
  null
  
)

export default component.exports